import React, { useState, useEffect } from 'react'
import { Panel, Row, Col, ControlLabel, Input, DatePicker } from 'rsuite'

import { isRequired, isValidators, requiredFiled } from '../../utils/ValidatorUtils'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import classNames from 'classnames'
import moment from 'moment'
import { DATE_PICKER_FORMAT, LOCAL_DAY_TH } from '../../constants/date'
import './styles.less'

export default function MainProjectForm({
  schema: _schema,
  register,
  errors,
  error,
  Controller,
  control,
  setValue,
  clearErrors,
  getValues,
  onChange,
  onChangeReportDate,
  ...props
}) {
  const { isDeleteError, isError, loading, hideHeader } = props
  const [schema, setSchema] = useState(_schema)

  return (
    <>
      <Panel
        header={schema.header}
        bordered
        collapsible={false}
        defaultExpanded
        shaded
        className="rs-panel-bordered-sty"
        style={{ backgroundColor: '#2ca8881a' }}
      >
        <Row>
          <Col
            lg={3}
            md={3}
            sm={5}
            xs={5}
            style={{
              marginTop: '5px',
              padding: '8px',
              textAlign: 'right',
            }}
          >
            {`${schema.projectNameTitle || 'โครงการ'} : `}
          </Col>
          <Col lg={21} md={21} sm={19} xs={19} style={{ marginTop: '5px', padding: '8px' }}>
            {schema.projectCode && (
              <b style={{ paddingRight: '5px', color: '#2da888' }}>{schema.projectCode}</b>
            )}

            {schema.projectNameTH && (
              <b style={{ paddingRight: '5px', color: '#2da888' }}>{schema.projectNameTH}</b>
            )}

            {schema.projectNameEN && (
              <b style={{ paddingRight: '5px', color: '#2da888' }}>{schema.projectNameEN}</b>
            )}
          </Col>
        </Row>

        <Row>
          <Col
            lg={3}
            md={3}
            sm={5}
            xs={5}
            style={{
              marginTop: '5px',
              padding: '8px',
              textAlign: 'right',
            }}
          >
            <ControlLabel
              className={classNames(
                'style-text-lable',
                isRequired(schema.reportDate.validators) && 'required'
              )}
            >
              {schema.reportDate.label}
            </ControlLabel>
          </Col>
          <Col lg={9} md={9} sm={19} xs={19} style={{ marginTop: '5px', padding: '8px' }}>
            <ErrorMessage error={errors[schema.reportDate.name]} />
            <Controller
              key={schema.reportDate.name}
              name={schema.reportDate.name}
              control={control}
              defaultValue={
                // moment(schema.reportDate.value).format('YYYY-MM-DD')
                schema.reportDate.value
                  ? moment(schema.reportDate.value, DATE_PICKER_FORMAT).toDate()
                  : moment().startOf('day').toDate()
              }
              rules={isValidators(schema.reportDate.validators)}
              render={(props) => {
                return (
                  <DatePicker
                    format={DATE_PICKER_FORMAT}
                    locale={LOCAL_DAY_TH}
                    block
                    value={props.value}
                    onChange={(value) => {
                      props.onChange(value)
                      onChangeReportDate(value)
                    }}
                  />
                )
              }}
            />
          </Col>
        </Row>

        <Row>
          <Col
            lg={3}
            md={3}
            sm={5}
            xs={5}
            style={{
              marginTop: '5px',
              padding: '8px',
              textAlign: 'right',
            }}
          >
            {schema.note.label}
          </Col>
          <Col lg={9} md={9} sm={19} xs={19} style={{ marginTop: '5px', padding: '8px' }}>
            <Input
              name={schema.note.name}
              defaultValue={schema.note.value || ''}
              componentClass="textarea"
              placeholder={schema.note.label}
              inputRef={register()}
            />
          </Col>
        </Row>
      </Panel>
    </>
  )
}
